import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PdfSpacerComponent } from './pdf-spacer.component';


@NgModule({
  declarations: [
    PdfSpacerComponent
  ],
  exports: [
    PdfSpacerComponent
  ],
  imports: [
    CommonModule,
  ],
  providers: []
})
export class PdfSpacerModule { }
